import React from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import './Layout.css'

type Props = { children: React.ReactNode }

export const Layout: React.FC<Props> = ({ children }) => (
  <div className="app-container">
    <Header />
    <div className="layout">
      <Sidebar />
      <main className="main-content">{children}</main>
    </div>
  </div>
)
